import { CSSObject } from '@mui/system';
import { alpha } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';

/** Global native scrollbars, including portaled chats/dialogs; retain OS high-contrast controls. */
export function portalScrollbarStyles(theme: Theme): CSSObject {
	const thumb = alpha(theme.palette.text.primary, 0.5);
	return {
		'@media (forced-colors: none)': {
			'*': { scrollbarWidth: 'thin', scrollbarColor: `${thumb} transparent` },
			// Chromium supports both APIs. Reset the standard properties here so the rounded
			// WebKit thumb/hover styles take effect; Firefox keeps the standard thin scrollbar.
			'@supports selector(::-webkit-scrollbar)': {
				'*': { scrollbarWidth: 'auto', scrollbarColor: 'auto' },
				'*::-webkit-scrollbar': { width: 10, height: 10 },
				'*::-webkit-scrollbar-track': { backgroundColor: 'transparent' },
				'*::-webkit-scrollbar-thumb': {
					backgroundColor: thumb, backgroundClip: 'padding-box', border: '2px solid transparent', borderRadius: 10,
				},
				'*::-webkit-scrollbar-thumb:hover': { backgroundColor: alpha(theme.palette.text.primary, 0.7) },
				'*::-webkit-scrollbar-thumb:active': { backgroundColor: theme.palette.text.secondary },
				'*::-webkit-scrollbar-corner': { backgroundColor: 'transparent' },
				'*::-webkit-scrollbar-button': { display: 'none', width: 0, height: 0 },
			},
		},
	};
}
